import { render, staticRenderFns } from "./ProfileListItem.vue?vue&type=template&id=67e230b0&scoped=true&"
import script from "./ProfileListItem.vue?vue&type=script&lang=js&"
export * from "./ProfileListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileListItem.vue?vue&type=style&index=0&id=67e230b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e230b0",
  null
  
)

export default component.exports